(function () {
  const STORAGE_PREFIX = "dt_card_size_";

  function keyFor(container) {
    const pid = container.getAttribute("data-product-id") || "";
    const handle = container.getAttribute("data-product-handle") || "";
    return STORAGE_PREFIX + (pid || handle);
  }

  function pills(container) {
    return Array.from(container.querySelectorAll(".dt-sizes__pill"));
  }

  function setSelectedUI(container, value) {
    pills(container).forEach((p) => {
      const is = p.getAttribute("data-size-value") === value;
      p.classList.toggle("is-selected", is);
      p.setAttribute("aria-pressed", is ? "true" : "false");
    });
  }

  function updateAvailabilityUI(container) {
    pills(container).forEach((p) => {
      const available = p.getAttribute("data-available") === "true";
      p.classList.toggle("is-unavailable", !available);
    });
  }

  function setAddState(container, { enabled, hidden }) {
    const add = container.querySelector("[data-dt-add]");
    if (!add) return;

    add.classList.toggle("is-hidden", !!hidden);

    if (enabled && !hidden) {
      add.disabled = false;
      add.setAttribute("aria-disabled", "false");
    } else {
      add.disabled = true;
      add.setAttribute("aria-disabled", "true");
    }
  }

  // ---------- Slider helpers ----------
  function setupSlider(container) {
    const scroller = container.querySelector("[data-dt-sizes-scroller]");
    const prev = container.querySelector("[data-dt-sizes-prev]");
    const next = container.querySelector("[data-dt-sizes-next]");
    if (!scroller || !prev || !next) return;

    const update = () => {
      const overflow = scroller.scrollWidth > scroller.clientWidth + 1;
      container.classList.toggle("is-scrollable", overflow);

      // Mostrar/ocultar flechas
      prev.hidden = !overflow;
      next.hidden = !overflow;

      if (!overflow) return;

      // Estado de flechas
      const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
      const left = scroller.scrollLeft;

      prev.disabled = left <= 1;
      next.disabled = left >= maxScrollLeft - 1;

      prev.style.opacity = prev.disabled ? "0.25" : "0.9";
      next.style.opacity = next.disabled ? "0.25" : "0.9";
    };

    const scrollByAmount = (dir) => {
      // ~6 tallas por "paso" (ajustado a HOFF)
      const step = Math.max(140, Math.round(scroller.clientWidth * 0.6));
      scroller.scrollBy({ left: dir * step, behavior: "smooth" });
    };

    prev.addEventListener("click", () => scrollByAmount(-1));
    next.addEventListener("click", () => scrollByAmount(1));
    scroller.addEventListener("scroll", () => update());

    // ResizeObserver: recalcular cuando cambie el ancho del card
    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(() => update());
      ro.observe(scroller);
      // guardamos ref para no GC
      container.__dtSizesRO = ro;
    } else {
      window.addEventListener("resize", update);
    }

    // Primer cálculo (después del render)
    // Recalcular varias veces porque en grids el layout cambia tras cargar fuentes/imagenes
requestAnimationFrame(update);
setTimeout(update, 60);
setTimeout(update, 250);
window.addEventListener("load", update, { once: true });
  }

  // ---------- 1) Intentar usar el form real del tema ----------
  function findNativeProductForm(container) {
    const root =
      container.closest(
        "[data-product-id], .card, .product-card, .product-block, .product-grid-item, li, article, .grid__item"
      ) || container;

    const form = root.querySelector('form[action*="/cart/add"]');
    if (form) return form;

    const productFormEl = root.querySelector("product-form");
    if (productFormEl) {
      const inner = productFormEl.querySelector('form[action*="/cart/add"]');
      if (inner) return inner;
    }

    return null;
  }

  function setVariantIdOnForm(form, variantId) {
    if (!form) return false;
    let idInput = form.querySelector('input[name="id"]');
    if (!idInput) {
      idInput = document.createElement("input");
      idInput.type = "hidden";
      idInput.name = "id";
      form.appendChild(idInput);
    }
    idInput.value = String(variantId);
    return true;
  }

  async function submitNativeForm(form) {
    if (!form) throw new Error("No form");

    const submitBtn =
      form.querySelector('button[type="submit"], input[type="submit"]') ||
      form.querySelector(
        '[name="add"], [data-add-to-cart], .product-form__submit, .product-card__quick-add-button'
      );

    if (submitBtn) {
      submitBtn.click();
      return;
    }

    if (typeof form.requestSubmit === "function") {
      form.requestSubmit();
      return;
    }

    form.submit();
  }

  // ---------- 2) Fallback AJAX universal ----------
  async function ajaxAdd(variantId, quantity = 1) {
    const root = window.Shopify?.routes?.root || "/";
    const res = await fetch(`${root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) }),
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(text || "Error adding to cart");
    }

    const data = await res.json();
    notifyThemeAfterAjaxAdd(variantId, data);
    return data;
  }

  // ---------- 3) Adaptadores por tema ----------
  function notifyThemeAfterAjaxAdd(variantId, data) {
    // Dawn/Trade + genérico
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: data }));

    // Palo Alto
    document.dispatchEvent(new CustomEvent("theme:cart:refresh", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("theme:cart:added", { bubbles: true }));

    // Mode
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:cartchanged", {
        bubbles: true,
        cancelable: false,
        detail: { openDrawer: true },
      })
    );

    // Impulse (abre/recarga drawer con ajaxProduct:added)
    if (window.theme && window.theme.routes && window.theme.routes.cartAdd) {
      const dummyForm = document.createElement("form");
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "id";
      input.value = String(variantId);
      dummyForm.appendChild(input);

      dummyForm.dispatchEvent(new CustomEvent("ajaxProduct:added", { bubbles: true }));
    }
  }

  function applyStoredSelection(container) {
    const stored = sessionStorage.getItem(keyFor(container));
    if (!stored) return;

    const pill = container.querySelector(
      `.dt-sizes__pill[data-size-value="${CSS.escape(stored)}"]`
    );

    if (!pill) {
      sessionStorage.removeItem(keyFor(container));
      return;
    }

    setSelectedUI(container, stored);

    const available = pill.getAttribute("data-available") === "true";
    container.dataset.selectedSizeValue = stored;
    container.dataset.selectedVariantId = available
      ? pill.getAttribute("data-variant-id")
      : "";

    if (available) setAddState(container, { enabled: true, hidden: false });
    else setAddState(container, { enabled: false, hidden: true });
  }

  function init(container) {
    updateAvailabilityUI(container);

    // Estado inicial: visible pero deshabilitado hasta elegir
    setAddState(container, { enabled: false, hidden: false });

    applyStoredSelection(container);
    setupSlider(container);

    container.addEventListener("click", (e) => {
      const pill = e.target.closest(".dt-sizes__pill");
      if (!pill) return;

      const sizeValue = pill.getAttribute("data-size-value");
      const variantId = pill.getAttribute("data-variant-id");
      const available = pill.getAttribute("data-available") === "true";

      setSelectedUI(container, sizeValue);
      sessionStorage.setItem(keyFor(container), sizeValue);

      container.dataset.selectedSizeValue = sizeValue;
      container.dataset.selectedVariantId = available ? variantId : "";

      if (available) {
        setAddState(container, { enabled: true, hidden: false });
      } else {
        // EXACTO: si seleccionas no disponible → desaparece el botón
        setAddState(container, { enabled: false, hidden: true });
      }
    });

    const addBtn = container.querySelector("[data-dt-add]");
    if (addBtn) {
      addBtn.addEventListener("click", async () => {
        const variantId = container.dataset.selectedVariantId;
        if (!variantId) return;

        addBtn.disabled = true;
        addBtn.setAttribute("aria-disabled", "true");

        try {
          const form = findNativeProductForm(container);
          if (form && setVariantIdOnForm(form, variantId)) {
            await submitNativeForm(form);
          } else {
            await ajaxAdd(variantId, 1);
          }
        } catch (err) {
          console.error("[DT Sizes] Add error:", err);
        } finally {
          const still = container.dataset.selectedVariantId;
          const hidden = addBtn.classList.contains("is-hidden");
          if (still && !hidden) {
            addBtn.disabled = false;
            addBtn.setAttribute("aria-disabled", "false");
          }
        }
      });
    }
  }

  function initAll(root = document) {
    root.querySelectorAll("[data-dt-sizes]").forEach((el) => {
      if (el.__dtSizesInit) return;
      el.__dtSizesInit = true;
      init(el);
    });
  }

  document.addEventListener("DOMContentLoaded", () => initAll());
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  document.addEventListener("dt:cards:rendered", (e) => initAll(e.target || document));
})();
